import { agriculturalIotUseCase } from './agricultural-iot/data';
import { eventPlanningVenuesUseCase } from './event-planning-venues/data';

export const allUseCases = [
  agriculturalIotUseCase,
  eventPlanningVenuesUseCase,
  // Add new use cases here as you create them
]; 